module.exports = function(options) {

    return {
        ...options,

        // Overwrite options
        language: 'nl',

        contentsCss: [],

        toolbarGroups: [
            { name: 'document', groups: ['mode', 'document', 'doctools', 'source', 'embed'] },
            { name: 'clipboard', groups: ['clipboard', 'undo'] },
            { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
            { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
            { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
            { name: 'link', groups: ['links'] },
            { name: 'styles', groups: ['styles'] },
        ],
        removeButtons: 'PasteFromWord,Paste,Copy,Replace,Find,SelectAll,Source,Scayt,Form,Checkbox,Radio,Textarea,Select,TextField,Button,HiddenField,Save,Preview,Print,NewPage,Templates,Strike,Subscript,Superscript,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,JustifyBlock,Language,BidiRtl,BidiLtr,Anchor,Flash,HorizontalRule,PageBreak,Iframe,FontSize,Font,BGColor,ShowBlocks,Maximize,About,SpecialChar',

        // Add styles
        stylesSet: [
            {name: 'Normal', element: 'span', attributes: {'class': ''}},
        ],


    };

};
